module.exports = __webpack_public_path__ + "cement/img/组-3892.dd851dc9.jpg";